import { Text, View } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

const GenProdSpec = ({ styles, techData }) => {
  const { t } = useTranslation();
  return (
    <View style={styles["section-wrapper"]}>
      <View style={styles.heading}>
        <Text style={styles.title}>
          {t("techCard.GenProdSpec.Title").toUpperCase()}
        </Text>
      </View>
      <View style={styles.flex}>
        <View style={{ ...styles.left, paddingRight: "5px" }}>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>{t("techCard.GenProdSpec.Range")}:</Text>
            <Text style={styles.value}>
              {/* {techData.generalProductSpec.range} */}
              Climate
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.GenProdSpec.SubRange")}:
            </Text>
            <Text style={styles.value}>
              {techData.generalProductSpec.subRange}
            </Text>
          </View>
          <View
            style={{
              ...styles["md-flex"],
            }}
          >
            <Text style={{ ...styles.label, width: "30%" }}>
              {t("techCard.GenProdSpec.Installation")}:
            </Text>
            <Text style={styles.value}>
              {t(`unitTypeList.${techData.generalProductSpec.installation}`)}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.GenProdSpec.Arrangement")}:
            </Text>
            <Text style={styles.value}>
              {techData.generalProductSpec.arrangement}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.GenProdSpec.PanelThickness")}:
            </Text>
            <Text style={styles.value}>
              {techData.generalProductSpec.panelThickness}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.GenProdSpec.Weight")} kg:
            </Text>
            <Text style={styles.value}>
              {techData.generalProductSpec.weight}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.GenProdSpec.Width")} mm(W):
            </Text>
            <Text style={styles.value}>
              {techData.generalProductSpec.width}
            </Text>
          </View>
        </View>
        <View style={styles.right}>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.GenProdSpec.PanelIntern")}:
            </Text>
            <Text style={styles.value}>
              {techData.generalProductSpec.panelInternal}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.GenProdSpec.PanelExtern")}:
            </Text>
            <Text style={styles.value}>
              {techData.generalProductSpec.panelExternal}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.GenProdSpec.Insulation")}:
            </Text>
            <Text style={styles.value}>
              {techData.generalProductSpec.insulation}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.GenProdSpec.UnitBase")}:
            </Text>
            <Text style={styles.value}>
              {techData.generalProductSpec.unitBase}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.GenProdSpec.UnitBaseHeight")} mm:
            </Text>
            <Text style={styles.value}>
              {techData.generalProductSpec.unitBaseHeight}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("projectitemrevision.height")} mm(H):
            </Text>
            <Text style={styles.value}>
              {techData.generalProductSpec.height}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.GenProdSpec.Length")} mm(L) :
            </Text>
            <Text style={styles.value}>
              {techData.generalProductSpec.length}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.GenProdSpec.Length")}1 mm(L1) :
            </Text>
            <Text style={styles.value}>
              {techData.generalProductSpec.lengthL1}
            </Text>
          </View>
        </View>
      </View>

      <View
        style={{
          ...styles.flex,
          border: "1px solid #80caef",
          marginTop: "0px",
        }}
      >
        <View style={{ ...styles.left, paddingRight: "5px" }}>
          <Text style={styles["sm-title"]}>
            {t("techCard.SupplySide").toUpperCase()}
          </Text>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>{t("techCard.GenProdSpec.Type")}:</Text>
            <Text style={styles.value}>
              {techData.generalProductSpec.supplySide.type}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.GenProdSpec.Section")}:
            </Text>
            <Text style={styles.value}>
              {techData.generalProductSpec.supplySide.section}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>{t("techCard.AirVolFlow")} [m³/h]:</Text>
            <Text style={styles.value}>
              {techData.generalProductSpec.supplySide.airVolumeFlow}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.GenProdSpec.ExternPressDrop")} [Pa]:
            </Text>
            <Text style={styles.value}>
              {techData.generalProductSpec.supplySide.externalPressureDrop}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.GenProdSpec.ServicingSide")}:
            </Text>
            <Text style={styles.value}>
              {techData.generalProductSpec.supplySide.servicingSide}
            </Text>
          </View>
          {techData.calculation.rec_Type === "Rotary" ? (
            <View style={styles["md-flex"]}>
              <Text style={styles.label}>Supply air:</Text>
              <Text style={styles.value}>
                {techData.calculation.airflowDirection == 1 ||
                techData.calculation.airflowDirection == 2
                  ? "Lower zone"
                  : "Upper zone"}
              </Text>
            </View>
          ) : null}
        </View>
        <View style={styles.right}>
          <Text style={styles["sm-title"]}>
            {t("techCard.ExhaustSide").toUpperCase()}
          </Text>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>{t("techCard.GenProdSpec.Type")}:</Text>
            <Text style={styles.value}>
              {techData.generalProductSpec.exhaustSide.type}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.GenProdSpec.Section")}:
            </Text>
            <Text style={styles.value}>
              {techData.generalProductSpec.exhaustSide.section}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>{t("techCard.AirVolFlow")} [m³/h]:</Text>
            <Text style={styles.value}>
              {techData.generalProductSpec.exhaustSide.airVolumeFlow}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.GenProdSpec.ExternPressDrop")} [Pa]:
            </Text>
            <Text style={styles.value}>
              {techData.generalProductSpec.exhaustSide.externalPressureDrop}
            </Text>
          </View>
          <View style={styles["md-flex"]}>
            <Text style={styles.label}>
              {t("techCard.GenProdSpec.ServicingSide")}:
            </Text>
            <Text style={styles.value}>
              {techData.generalProductSpec.exhaustSide.servicingSide}
            </Text>
          </View>
          {techData.calculation.rec_Type === "Rotary" ? (
            <View style={styles["md-flex"]}>
              <Text style={styles.label}>Exhaust air:</Text>
              <Text style={styles.value}>
                {techData.calculation.airflowDirection == 1 ||
                techData.calculation.airflowDirection == 2
                  ? "Upper zone"
                  : "Lower zone"}
              </Text>
            </View>
          ) : null}
        </View>
      </View>
    </View>
  );
};

export default GenProdSpec;
